export default __webpack_public_path__ + "static/media/digger-1-point-5-768x514.a6fe00f4.jpg";